import { bindServices } from '@/services/api';
import { toImportExcel } from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import _ from 'lodash';
import { filtersConfig } from './utils';

const namespace = 'processPortal';
const api = bindServices(namespace);

export const initialPagination = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  isOpenModal: false,
  showForm: false,
  detail: false,
  selectedItem: null,
  pagination: initialPagination,
  view: false,
  orderBy: '',
  showDetail: false,
  processPortalList: [],
  processConfigList: [],
  latestFetchProcessPortalList: null,
  isConfig: false,
  idSelected: '',
  showImport: false,
  success: false,
  validationErrors: [],
};

const Model = {
  namespace,

  state: {
    ...initialState,
    orderBy: 'name asc',
    filtersConfig,
  },

  effects: {
    *fetchData({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[namespace].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : 'processportal/paged',
          params: {
            limit: pageSize,
            ...CoreQueries.ManageProcess.Portal,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        yield put({
          type: 'queryProcessPortal',
          payload: {
            ...res,
            page: payload.page,
            limit: pageSize,
          },
        });

        yield put({
          type: 'saveLatestFetchProcessPortal',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *editProcessPortal({ payload }, { call, put }) {
      try {
        const id = payload.data.id;
        const data = { ...payload.data };
        delete data.id;
        const response = yield call(api.updateById, {
          id,
          route: 'processportal',
          data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({ type: 'saveProcessPortal', payload: response });

        yield put({
          type: 'repeatLatestFetchProcessPortal',
        });
      } catch (error) {
        if (error.message) {
          return yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }

        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'error',
          },
        });
      }
    },
    *editActive({ payload }, { call, put }) {
      try {
        yield call(api.activate, {
          route: 'processportal',
          id: payload.id,
          isActive: payload.isActive,
        });
        yield put({ type: 'processPortalActive', payload });
      } catch (e) {
        throw e;
      }
    },
    *openModalProcessPortal({ payload }, { put }) {
      yield put({
        type: 'openModalOrSelectItemProcessPortal',
        payload,
      });

      if (!_.isNil(payload.id)) {
        yield put({
          type: 'getInfoProcessPortal',
          payload: { params: payload, id: payload.id },
        });
      }
    },
    *openModalDetail({ payload }, { call, put }) {
      try {
        const res = yield call(api.getById, {
          route: 'processportal',
          id: payload.id,
          params: {
            ...CoreQueries.ManageProcess.PortalDetail,
            ...(payload?.params && { ...payload.params }),
          },
        });

        yield put({
          type: 'queryGetDetail',
          payload: res,
        });
      } catch (error) {
        /*  */
      }
    },
    *openModalConfig({ payload }, { call, put, select }) {
      try {
        const state = yield select((state) => state.processPortal);
        const portalItem = state.processPortalList.find((item) => item.id === payload.id);

        yield put({
          type: 'queryGetConfig',
          payload: {
            idSelected: payload.id,
            dataCountConfigs: {},
            selectedItem: portalItem || null,
          },
        });

        const params = { route: `processPortal/config/${payload.id}` };
        const dataCountConfigs = yield call(api.getAll, params);

        yield put({
          type: 'queryGetConfig',
          payload: { idSelected: payload.id, dataCountConfigs, selectedItem: portalItem || null },
        });
      } catch (error) {
        /*  */
      }
    },
    *refreshConfig(__, { call, put, select }) {
      try {
        const idSelected = yield select((state) => state.processPortal.idSelected);
        const params = { route: `processPortal/config/${idSelected}` };
        const dataCountConfigs = yield call(api.getAll, params);
        yield put({
          type: 'queryGetConfig',
          payload: { idSelected, dataCountConfigs },
        });
      } catch (error) {
        /*  */
      }
    },
    *getInfoProcessPortal({ payload }, { call, put }) {
      try {
        const res = yield call(api.getById, {
          route: 'processportal',
          id: payload.id,
          params: {
            ...CoreQueries.ManageProcess.PortalDetail,
            ...(payload?.params && { ...payload.params }),
          },
        });

        yield put({
          type: 'setInfoProcessPortal',
          payload: res,
        });
      } catch (error) {}
    },
    *fetchItem({ payload }, { call, put }) {
      try {
        const params = payload.detail
          ? CoreQueries.ManageProcess.PortalDetail
          : CoreQueries.ManageProcess.PortalDetail;
        const res = yield call(api.getById, {
          route: 'processportal',
          id: payload.id,
          params,
        });

        yield put({
          type: 'setInfoProcessPortal',
          payload: res,
        });
      } catch (error) {
        /*  */
      }
    },
    *generateUrl({ payload }, { call, put }) {
      try {
        yield call(api.exec, {
          route: `processPortal/generatePublicUrl/${payload}`,
          httpMethod: 'post',
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'repeatLatestFetchProcessPortal',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsform',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *desactivateUrl({ payload }, { call, put }) {
      try {
        yield call(api.exec, {
          route: `processPortal/deactivatePublicUrl/${payload}`,
          httpMethod: 'post',
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'repeatLatestFetchProcessPortal',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsform',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *publish({ payload }, { call, put }) {
      try {
        yield call(api.exec, {
          route: `processPortal/publish/${payload}`,
          httpMethod: 'post',
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsform',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *saveNewProcessPortal({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'processPortal',
          data: payload.data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveProcessPortal',
          payload: response,
        });

        yield put({
          type: 'repeatLatestFetchProcessPortal',
        });
      } catch (error) {
        if (error.message) {
          return yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }

        yield put({
          type: 'global/showNotificationsForm',
          payload: {
            visible: true,
            type: 'error',
          },
        });
      }
    },
    *deleteItem({ id, view }, { call, put }) {
      try {
        yield put({
          type: 'global/modalConfirm',
          state: false,
          id: null,
        });

        const response = yield call(api.remove, {
          id,
          route: 'processportal',
        });

        yield put({
          type: 'deleteProcessPortal',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'repeatLatestFetchProcessPortal',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *addListProcess({ payload }, { put }) {
      yield put({
        type: 'addProcessToList',
        payload,
      });
    },
    *deleteProcessFromList({ payload }, { put }) {
      yield put({
        type: 'removeProcessToList',
        payload,
      });

      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
    },
    *saveNewListProcess({ payload }, { call, put }) {
      try {
        yield call(api.exec, {
          route: `processPortalProcess/updatePortalProcesses/${payload.idSelected}`,
          httpMethod: 'post',
          data: payload.data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'hideConfig',
          payload: {
            state: false,
            item: null,
            form: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsform',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *repeatLatestFetchProcessPortal(__, { put, select }) {
      const latestPayload = yield select(
        (state) => state.processPortal.latestFetchProcessPortalList,
      );

      yield put({ type: 'fetchData', payload: latestPayload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
      if (payload.id) {
        yield put({
          type: 'fetchItem',
          payload: {
            id: payload.id,
            detail: true,
          },
        });
      }
    },
    *fetchImport({ payload }, { call, put }) {
      try {
        const { file, isDeleteData } = payload;
        const res = yield call(toImportExcel, {
          route: 'processPortal',
          fileContent: file,
          deleteExistingData: isDeleteData,
        });

        yield put({
          type: 'queryImport',
          payload: { ...res },
        });

        yield put({
          type: 'fetchData',
          payload: {
            page: 1,
            limit: 5,
          },
        });
      } catch (e) {
        /*  */
      }
    },
    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },
    *clearConfigCache(_, { put }) {
      yield put({
        type: 'processPortalConfig/clearConfigCache',
      });
    },
  },

  reducers: {
    updateConfigCount(state, { payload }) {
      const { idConfig, count } = payload;
      // Map 'config-process' -> 'processes', 'config-report' -> 'reports', etc.
      const configKeyMap = {
        'config-process': 'processes',
        'config-report': 'reports',
        'config-entity': 'entities',
        'config-list': 'lists',
        'config-permission': 'permissions',
        'config-menu': 'menus',
      };
      const countKey = configKeyMap[idConfig];

      return {
        ...state,
        dataCountConfigs: {
          ...state.dataCountConfigs,
          [countKey]: count,
        },
      };
    },
    queryProcessPortal(state, { payload }) {
      return {
        ...state,
        processPortalList: payload.items.map((item) => ({
          ...item,
          isActive: item.isActive ?? false,
        })),
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    processPortalActive(state, { payload }) {
      const list = state.processPortalList.map((item) =>
        item.id === payload.id ? { ...item, isActive: payload.isActive } : item,
      );
      return {
        ...state,
        processPortalList: list,
      };
    },
    queryGetDetail(state, { payload }) {
      return { ...state, selectedItem: payload, showDetail: true, isConfig: false };
    },
    setInfoProcessPortal(state, { payload }) {
      return { ...state, selectedItem: payload };
    },
    queryGetConfig(state, { payload }) {
      return {
        ...state,
        isConfig: true,
        showDetail: false,
        idSelected: payload.idSelected,
        dataCountConfigs: payload.dataCountConfigs,
        selectedItem: payload.selectedItem || state.selectedItem,
      };
    },
    saveProcessPortal(state, { payload }) {
      return {
        ...state,
        saveProcessPortal: payload,
        isOpenModal: false,
        showForm: false,
        selectedItem: null,
        id: null,
        orderBy: '',
        success: true,
      };
    },
    showForm(state, { payload }) {
      return {
        ...state,
        showForm: payload.state,
        detail: payload.detail,
        id: payload.id,
        success: false,
        validationErrors: [],
        selectedItem: payload.item || null,
      };
    },
    openModalOrSelectItemProcessPortal(state, { payload }) {
      return {
        ...state,
        isOpenModal: payload.isOpenModal,
        showDetail: false,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        isConfig: false,
      };
    },
    deleteProcessPortal(state) {
      return { ...state };
    },
    selectItem(state, { payload }) {
      const item = state.processPortalList.find((entity) => entity.id === payload.id);

      return {
        ...state,
        selectedItem: item,
        view: payload.view,
        id: payload.id,
      };
    },
    showDetails(state, { payload }) {
      return {
        ...state,
        showDetail: payload,
      };
    },
    showConfig(state, { payload }) {
      return {
        ...state,
        isConfig: payload,
      };
    },
    hideConfig(state) {
      return {
        ...state,
        selectedItem: null,
        processConfigList: [],
        isConfig: false,
        // Don't clear processPortalList - keep the list intact
      };
    },
    addProcessToList(state, { payload }) {
      return {
        ...state,
        processConfigList: [...state.processConfigList, payload],
      };
    },
    removeProcessToList(state, { payload }) {
      return {
        ...state,
        processConfigList: state.processConfigList.filter((item) => item.id !== payload),
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        showForm: payload.state,
        showDetail: payload.state,
        detail: true,
        selectedItem: {},
        view: payload.view || true,
      };
    },
    resetState(state) {
      // Preserve the list and pagination when resetting
      const preservedList = state?.processPortalList || [];
      const preservedPagination = state?.pagination || initialPagination;

      return {
        ...initialState,
        filtersConfig,
        processPortalList: preservedList,
        pagination: preservedPagination,
      };
    },
    saveLatestFetchProcessPortal(state, { payload }) {
      return {
        ...state,
        latestFetchProcessPortalList: payload,
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
